<script setup>
import ProgressSpinner from "primevue/progressspinner";

defineOptions({
  name: "MobileAppRedirect",
});

const logo = `${import.meta.env.VITE_CDN_ENDPOINT}/images/api-connect-logo.png`;
</script>

<template>
  <div class="flex flex-col items-center pt-12">
    <img
      class="w-48 object-contain h-8 mb-6"
      :src="logo"
    />
    <ProgressSpinner style="width: 45px; height: 45px;" />
    <p class="text-blue-darker text-sm font-medium">Opening APIConnect App...</p>
  </div>
</template>

<style scoped>
::v-deep(.progress-spinner-circle) {
  @apply !stroke-blue-darker;
}
</style>
